import type { SVGProps } from "react";
export interface PoolIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PoolIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PoolIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.691 18.884a1.77 1.77 0 0 1 1.95 0l.123.089.196.15c.46.333 1.129.696 1.868.746l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.306-.085-2.371-.687-3.02-1.153-.701.503-1.885 1.163-3.333 1.163s-2.634-.66-3.334-1.163c-.7.503-1.885 1.163-3.333 1.163s-2.633-.66-3.333-1.163c-.701.503-1.885 1.163-3.333 1.163a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.514 2.237-.902l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.359 1.233.752 2.04.752.922 0 1.755-.514 2.236-.902l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.359 1.232.752 2.039.752.923 0 1.755-.514 2.237-.902l.121-.09Zm0-4a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.332 1.129.695 1.868.745l.172.006.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006-.314-.01c-1.305-.086-2.371-.686-3.02-1.152-.701.503-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.503-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162c-.701.503-1.885 1.162-3.333 1.162a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.513 2.237-.901l.121-.09a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.357 1.233.75 2.04.75.922 0 1.755-.512 2.236-.9l.122-.09a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.357 1.232.75 2.039.75.922 0 1.755-.512 2.237-.9zM5.875 12.02V5.708a3.832 3.832 0 0 1 7.611-.63l.123.738.014.115a1.125 1.125 0 0 1-2.208.367l-.025-.112-.123-.739a1.582 1.582 0 0 0-3.142.261v3.168h7.25V5.707a3.832 3.832 0 0 1 7.612-.63l.123.738.014.115a1.127 1.127 0 0 1-2.21.367l-.024-.112-.123-.739a1.582 1.582 0 0 0-3.142.261v6.54a1.125 1.125 0 0 1-2.25 0v-1.121h-7.25v.895a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
